module.exports = __webpack_public_path__ + "img/18a001-06.58ccab06.jpg";